<template>
  <section class="ni-section ni-ask" id="qd-service">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="t('newIndex.sections.ask.subtitle')"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ t('newIndex.sections.ask.title') }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-ask__grid">
        <a
          v-for="srv in serviceItems"
          :key="srv.id"
          :id="`service-card-${srv.id}`"
          class="ni-ask__card"
          :href="srv.redirectUrl"
          target="_blank"
          rel="noopener noreferrer"
          :title="srv.title"
        >
          <div class="ni-ask__card-icon">
            <img :src="getServiceIcon(srv.id)" :alt="srv.title" class="ni-ask__card-icon-img" />
          </div>
          <div class="ni-ask__card-text">
            <div
              v-for="(line, lineIdx) in getCardTextLines(srv.id)"
              :key="lineIdx"
              :class="lineIdx === 0 ? 'ni-ask__card-line1' : 'ni-ask__card-line2'"
            >
              {{ line }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { serviceItems } from '@/data/newIndexMock.js';
import { getServiceIcon } from '@/data/newIndexAssets.js';
import SectionHeader from './shared/SectionHeader.vue';

const { t, tm } = useI18n();

function getCardTextLines(id) {
  const cards = tm('newIndex.sections.ask.cards');
  if (cards && cards[id]) {
    return cards[id];
  }
  return [];
}
</script>
